import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router';
import {
  deleteNotificationsSheetQueryParams,
  NOTIFICATIONS_SHEET_QUERY_PARAM,
  notificationsSheetSearchParamIndicatesOpen,
} from '~/lib/utils';

export function useNotificationsSheet() {
  const [searchParams, setSearchParams] = useSearchParams();
  const openFromUrl = notificationsSheetSearchParamIndicatesOpen(
    searchParams.get(NOTIFICATIONS_SHEET_QUERY_PARAM)
  );
  const [manualOpen, setManualOpen] = useState(false);
  const isOpen = openFromUrl || manualOpen;

  const clearUrlParam = useCallback(() => {
    setSearchParams(
      prev => {
        if (!prev.has(NOTIFICATIONS_SHEET_QUERY_PARAM)) return prev;
        const next = new URLSearchParams(prev);
        deleteNotificationsSheetQueryParams(next);
        return next;
      },
      { replace: true, preventScrollReset: true }
    );
  }, [setSearchParams]);

  const toggle = useCallback(() => {
    if (isOpen) {
      setManualOpen(false);
      clearUrlParam();
    } else {
      setManualOpen(true);
    }
  }, [isOpen, clearUrlParam]);

  const close = useCallback(() => {
    setManualOpen(false);
    clearUrlParam();
  }, [clearUrlParam]);

  return { isOpen, toggle, close };
}
